// Fontsource bundles the same Google Fonts with the application. Keeping these
// stable class names lets client components expose their existing CSS variables
// without making the production build depend on the Google Fonts CDN.
export const poppinsFont = { variable: 'font-poppins-local', className: 'font-poppins-local' } as const
export const bricolageFont = { variable: 'font-bricolage-local', className: 'font-bricolage-local' } as const
export const dmSansFont = { variable: 'font-dm-sans-local', className: 'font-dm-sans-local' } as const
